import { render, staticRenderFns } from "./LinkageField.vue?vue&type=template&id=53fe27eb&scoped=true&"
import script from "./LinkageField.vue?vue&type=script&lang=js&"
export * from "./LinkageField.vue?vue&type=script&lang=js&"
import style0 from "./LinkageField.vue?vue&type=style&index=0&id=53fe27eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe27eb",
  null
  
)

export default component.exports